<template>
  <div class="flex" role="tablist">
    <template v-for="tab in tabs" :key="'tab-' + tab.number">
      <button
        role="tab"
        :aria-selected="tab.number === activeTabNumber"
        class="p-4 text-sm font-medium border-b-2"
        :disabled="tab.isDisabled"
        :class="{
          'text-primary-500 border-primary-500': tab.number === activeTabNumber,
          'text-gray-500 border-transparent': tab.number !== activeTabNumber,
        }"
        @click="onClick(tab)"
      >
        <slot :tab="tab">
          {{ tab.title }}
        </slot>
      </button>
    </template>
  </div>
</template>

<script setup lang="ts">
type Tab = {
  number: number;
  title?: string;
  subtitle?: string;
  isDisabled?: boolean;
};
defineProps<{
  tabs: Tab[];
  activeTabNumber: number;
}>();
function onClick(tab: Tab) {
  emit("tab:clicked", tab);
}
const emit = defineEmits<(e: "tab:clicked", tab: Tab) => void>();
</script>
